export const MOBILE_BREAKPOINT_PX = 600; // update base.css
